import React, {Component} from 'react';
import {Checkbox, Col, FormControl, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import EBOKWiadomosciTable from "./components/EBOKWiadomosciTable";
import EBOKService from "./EBOKService";
import Select from 'react-select'
import ReactNotify from 'react-notify';
import KierowcaLogiTable from "../../administracja/logi/kierowcyTab/components/KierowcaLogiTable";

const options = [
    {value: 'WSZYSTKIE', label: 'Wszystkie'},
    {value: 'FAKTURY_CENY', label: 'Faktury / ceny'},
    {value: 'INFORMACJE', label: 'Informacje'},
    {value: 'ZWROT_BILETU', label: 'Zwrot biletu'},
    {value: 'INNE', label: 'Inne'}
];

const statusy = [
    {value: 0, label: "Wątek otwarty"},
    {value: 1, label: "Wątek zakończony"},
    {value: 2, label: "W realizacji"},
];

export default class EBOKContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wiadomosci: [],
            wybranyTemat: {value: 'WSZYSTKIE', label: 'Wszystkie'},
            status: null,
            czyMoznaZwrocic: false,
            email: '',
            nrBil: '',
            strona: 1,
            ilosc: 30,
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
        };

        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        this.pobierzZgloszenia()
    }

    handleChange = selectedOption => {
        if (selectedOption !== null) {
            this.setState({
                wybranyTemat: selectedOption,
                strona: 1,
                ilosc: 30,
                nrBil: '',
                czyMoznaZwrocic:false,
            });
            this.pobierzZgloszenia(1, 30, selectedOption, this.state.status,'',this.state.email,'')
        }
    }

    handleChangeStatus = selected => {
        this.setState({
            status: selected,
            strona: 1,
            ilosc: 30,
        })
        this.pobierzZgloszenia(1, 30, this.state.wybranyTemat, selected)
    }

    onChangeEmail = event => {
        this.setState({
            email: event.target.value
        })
        if (event.target.value.length >= 3 || event.target.value.length===0) {
            this.pobierzZgloszenia(1, 30, this.state.wybranyTemat, this.state.status, this.state.czyMoznaZwrocic, event.target.value)
        }
    }

    onChangeBilet = event => {
        this.setState({
            nrBil: event.target.value
        })
        if (event.target.value.length >= 3 || event.target.value.length===0) {
            this.pobierzZgloszenia(1, 30, this.state.wybranyTemat, this.state.status, this.state.czyMoznaZwrocic, this.state.email, event.target.value)
        }
    }

    onClickCzyZwrocic = event => {
        this.setState({
            czyMoznaZwrocic: event.target.checked,
            strona: 1,
            ilosc: 30
        })
        this.pobierzZgloszenia(1, 30, this.state.wybranyTemat, this.state.status, event.target.checked)
    }

    pobierzZgloszenia(strona = this.state.strona, ilosc = this.state.ilosc, typ = this.state.wybranyTemat, status = this.state.status, czyMoznaZwrocic = this.state.czyMoznaZwrocic, email = this.state.email, nrBil = this.state.nrBil) {

        if (status === null) {
            status=''
        } else {
            status = status.value;
        }

        if (!czyMoznaZwrocic) {
            czyMoznaZwrocic = ''
        }

        if(!email){
            email = ''
        }

        if(!nrBil){
            nrBil = ''
        }

        EBOKService.pobierzZgloszenia(strona - 1, ilosc, typ.value, status, czyMoznaZwrocic, email, nrBil).then(function (response) {
            let arr = Array.from(response.data.content, item => {
                return {...item, klient: item.imieKl + ' ' + item.nazKl}
            })
            this.setState({
                wiadomosci: arr,
                pageable: {
                    first: response.data.first,
                    last: response.data.last,
                    page: response.data.number,
                    size: response.data.size,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages,
                },
            })
        }.bind(this)).catch(function (err) {
            console.log(err)
        }.bind(this))
    }

    onChangeTemat(id, temat) {
        EBOKService.edytujTematZgloszenia(id, temat).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono temat w zgłoszeniu', "", 3000)
                this.pobierzZgloszenia(1, 30, this.state.wybranyTemat)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany tematu', "", 3000)
            }
        }.bind(this))
    }

    onSizePerPageList = (size) => {
        this.setState({ilosc: size})
        //this.pobierzZgloszenia(this.state.strona, size,this.state.wybranyTemat)
    }

    onPageChange = (page, sizePerPage) => {
        this.setState({strona: page})
        this.pobierzZgloszenia(page, sizePerPage, this.state.wybranyTemat)
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                              history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'KlienciContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/zarzadzanie-klientami',
                                    text: 'Zarządzanie klientami'
                                }, {addressUrl: '/zarzadzanie-klientami/ebok', text: 'eBOK'}]}/>
                                <SubHeader currentLink={this.props.match.path}
                                           obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <Row>
                                <Col lg={2}>
                                    <div>Wybierz temat: <span className={'req'}>*</span></div>
                                    <Select
                                        backspaceRemoves={false}
                                        clearable={false}
                                        value={this.state.wybranyTemat}
                                        onChange={this.handleChange}
                                        options={options}>
                                    </Select>
                                </Col>
                                <Col lg={2}>
                                    <div>Wybierz status:</div>
                                    <Select
                                        backspaceRemoves={false}
                                        clearable={true}
                                        value={this.state.status}
                                        onChange={this.handleChangeStatus}
                                        options={statusy}>
                                    </Select>
                                </Col>
                                <Col lg={2}>
                                    <div>Email zgłaszającego <span style={{color: "grey", fontSize: "10px", fontStyle: "italic"}}>(min 3 znaki)</span>
                                    </div>
                                    <FormControl value={this.state.email} onChange={this.onChangeEmail}/>
                                </Col>
                                {
                                    (this.state.wybranyTemat.value === "ZWROT_BILETU") ?
                                        <Col lg={2}>
                                            <div>Nr biletu <span style={{color: "grey", fontSize: "10px", fontStyle: "italic"}}>(min 3 znaki)</span>
                                            </div>
                                            <FormControl type="number" value={this.state.nrBil} onChange={this.onChangeBilet}/>
                                        </Col>
                                        : ""
                                }
                                {
                                    (this.state.wybranyTemat.value === "ZWROT_BILETU") ?
                                        <Col lg={3}>
                                            <div style={{height: '15px'}}></div>
                                            <Checkbox value={this.state.czyMoznaZwrocic} onClick={this.onClickCzyZwrocic}>Pokaż tylko te zwroty, które
                                                można zwrócić</Checkbox>
                                        </Col>
                                        : ""
                                }
                            </Row>

                        </Col>
                        <Col sm={12}>
                            <EBOKWiadomosciTable data={this.state.wiadomosci}
                                                 handleChangeTemat={(id, temat) => this.onChangeTemat(id, temat)}
                                                 pageable={this.state.pageable}
                                                 ilosc={this.state.ilosc}
                                                 strona={this.state.strona}
                                                 onSizePerPageList={this.onSizePerPageList}
                                                 onPageChange={this.onPageChange}
                                                 wybranyTemat={this.state.wybranyTemat.value}

                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>);
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eBOK/EBOKContainer.js